module.exports = __webpack_public_path__ + "img/hohlsaum_tieforange_ral2011.217c6b0d.jpg";